import { Component, computed, inject, input } from '@angular/core';
import { Business } from 'src/model/business';
import { FinanceAccount } from 'src/model/financeAccount.model';
import { FinanceAccountService } from 'src/services/finance-account.service';
import { DIALOG_CONTROLLER } from '../BaseDialog/dialog-controller';
import { ALERT_TYPE, SUCCESS_MESSAGES } from '../constants';
import { ConfirmationDialogComponent } from '../Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from '../Shared/shared-service.service';
import { getBankLogoByName } from '../bank.config';

@Component({
	selector: 'app-business-finance-account-list',
	templateUrl: './business-finance-account-list.component.html',
	styleUrl: './business-finance-account-list.component.scss',
	standalone: false
})
export class BusinessFinanceAccountListComponent {
	private sharedService = inject(SharedService);
	private faService = inject(FinanceAccountService);
	private dialog = inject(DIALOG_CONTROLLER, { optional: true });

	readonly getBankLogoByName = getBankLogoByName;

	business = input.required<Business>();
	allFaList = input.required<FinanceAccount[]>();
	faList = input.required<FinanceAccount[]>();
	sortedFaList = computed(() =>
		this.faList().sort((a, b) =>
			a.Disabled === b.Disabled ? 0
			: a.Disabled ? 1
			: -1
		)
	);
	faSelectionList = computed(() => this.allFaList().filter(fa => fa.Disabled !== true && !fa.BusinessIds?.includes(this.business().Id)));

	unlinkFA(fa: FinanceAccount) {
		const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
		const i = modalRef.componentInstance as ConfirmationDialogComponent;
		i.message = `Confirm to unlink this finance account ${fa.Bank} - ${fa.Description} [${fa.AccNumber}] from ${this.business().Name}?`;
		modalRef.result.then(async confirm => {
			if (confirm) {
				await this.faService.unlinkBusinessToFinanceAccount(fa.Id, this.business().Id);
				this.dialog?.close(fa);
				this.sharedService.openAlert(SUCCESS_MESSAGES.ACTION('unlinked', 'finance account'), ALERT_TYPE.SUCCESS);
			}
		});
	}
}
